/** A copy of `items` with the item at `from` moved to `to`. `to` is the index it
 *  ends up at, so the caller never has to adjust for its own removal. Out-of-range
 *  indices return the list unchanged rather than inventing an `undefined` row. */
export function arrayMove<T>(items: readonly T[], from: number, to: number): T[] {
  if (from === to || from < 0 || from >= items.length || to < 0 || to >= items.length) return [...items]
  const next = [...items]
  const [moved] = next.splice(from, 1)
  next.splice(to, 0, moved as T)
  return next
}
